var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.75,
    fill: "url(#paint0_linear_205_5)",
    fillOpacity: 0.3,
    stroke: "url(#paint1_linear_205_5)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.2083V17.6667H24.9167C25.4692 17.6667 25.9991 17.8862 26.3898 18.2769C26.7805 18.6676 27 19.1975 27 19.75V26.4167C27 26.9692 26.7805 27.4991 26.3898 27.8898C25.9991 28.2805 25.4692 28.5 24.9167 28.5H14.0833C13.5308 28.5 13.0009 28.2805 12.6102 27.8898C12.2195 27.4991 12 26.9692 12 26.4167V19.75C12 19.1975 12.2195 18.6676 12.6102 18.2769C13.0009 17.8862 13.5308 17.6667 14.0833 17.6667H14.5V16.2083C14.5 13.3708 16.5858 11 19.5 11C21.8267 11 23.6425 12.5208 24.265 14.5917C24.2909 14.6709 24.3007 14.7545 24.2938 14.8375C24.287 14.9205 24.2635 15.0014 24.225 15.0752C24.1864 15.1491 24.1334 15.2145 24.0692 15.2676C24.005 15.3207 23.9308 15.3604 23.851 15.3844C23.7712 15.4085 23.6874 15.4163 23.6046 15.4074C23.5217 15.3986 23.4415 15.3732 23.3685 15.3329C23.2956 15.2926 23.2315 15.2381 23.1799 15.1726C23.1284 15.1071 23.0904 15.032 23.0683 14.9517C22.5917 13.3667 21.2325 12.25 19.5 12.25C17.3517 12.25 15.75 13.9833 15.75 16.2083ZM13.25 19.75V26.4167C13.25 26.6377 13.3378 26.8496 13.4941 27.0059C13.6504 27.1622 13.8623 27.25 14.0833 27.25H24.9167C25.1377 27.25 25.3496 27.1622 25.5059 27.0059C25.6622 26.8496 25.75 26.6377 25.75 26.4167V19.75C25.75 19.529 25.6622 19.317 25.5059 19.1607C25.3496 19.0045 25.1377 18.9167 24.9167 18.9167H14.0833C13.8623 18.9167 13.6504 19.0045 13.4941 19.1607C13.3378 19.317 13.25 19.529 13.25 19.75Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_5",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357292,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685417,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_5",
    x1: 20.9863,
    y1: 40.063,
    x2: 22.7839,
    y2: 0.852792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101272,
    stopColor: "#D0E1FE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138542,
    stopColor: "#D0E1FE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857292,
    stopColor: "#777777",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockCell);
export default __webpack_public_path__ + "static/media/unlockCell.631f3c04b3ed3bad12651c171a995abd.svg";
export { ForwardRef as ReactComponent };